import {
  Button,
  FileInput,
  Modal,
  Select,
  TextInput,
  Textarea,
} from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import UserApi from '../../Api/UserApi';
import { fetchFileTypes } from '../../Actions/CommonFields';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { File as UserFile } from '../../Models/File';
import CommonApi from '../../Api/CommonApi';

export default function AddFileModal({
  show,
  setShow,
  selectedFile,
  getEquipmentFiles,
  manufacturerId = 0,
  equipmentId = 0,
  userId = 0,
  sitePageId = 0,
  equipmentFeatureId = 0,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  selectedFile: UserFile | null;
  getEquipmentFiles: () => Promise<void> | undefined;
  manufacturerId?: number;
  equipmentId?: number;
  userId?: number;
  sitePageId?: number;
  equipmentFeatureId?: number;
}) {
  const dispatch = useAppDispatch();
  const { fileTypes } = useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [fileUpload, setUploadFile] = useState<File | null>();
  const [formData, setFormData] = useState<UserFile>({
    id: 0,
    fileTypeId: null,
    fileUrl: null,
    dateAdded: null,
    addedBy: null,
    manufacturerId: manufacturerId,
    equipmentId: equipmentId,
    userId: userId,
    sitePageId: sitePageId,
    isPrimary: null,
    equipmentFeatureId: equipmentFeatureId,
    name: null,

    fileType: null,
  });

  const getReferences = async () => {
    if (!fileTypes.length) {
      await Promise.all([dispatch(fetchFileTypes())]);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getReferences();
  }, []);

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.currentTarget.files) {
      setUploadFile(event.currentTarget.files[0]);
    } else {
      setUploadFile(null);
    }
  }

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      manufacturerId === 0 &&
      equipmentId === 0 &&
      userId === 0 &&
      sitePageId === 0 &&
      equipmentFeatureId === 0
    ) {
      toast.error('Missing Key Id');
      return;
    }
    setButtonDisabled(true);

    try {
      setIsLoading(true);
      if (formData.id > 0) {
        return CommonApi.updateFile(formData)
          .then((res) => {
            if (res.data.success) {
              toast.success('File Updated');
              setIsLoading(false);
              setButtonDisabled(false);
              getEquipmentFiles();
              onCloseModal();
            } else {
              toast.error(res.data.message);
              setIsLoading(false);
              setButtonDisabled(false);
            }
          })
          .catch((err) => {
            toast.error('Error: ' + err);
            setIsLoading(false);
            setButtonDisabled(false);
          });
      } else {
        const fd = new FormData();
        fd.append('file', fileUpload!);
        fd.append('name', formData.name!);
        fd.append('fileTypeId', formData.fileTypeId!.toString());
        fd.append('manufacturerId', formData.manufacturerId!.toString());
        fd.append('equipmentId', formData.equipmentId!.toString());
        fd.append('userId', formData.userId!.toString());
        fd.append('sitePageId', formData.sitePageId!.toString());
        fd.append(
          'equipmentFeatureId',
          formData.equipmentFeatureId!.toString()
        );

        return CommonApi.addFile(fd)
          .then((res) => {
            if (res.data.success) {
              toast.success('File Uploaded');
              setIsLoading(false);
              setButtonDisabled(false);
              getEquipmentFiles();
              onCloseModal();
            } else {
              toast.error(res.data.message);
              setIsLoading(false);
              setButtonDisabled(false);
            }
          })
          .catch((err) => {
            toast.error('Error: ' + err);
            setIsLoading(false);
            setButtonDisabled(false);
          });
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  const handleSetInitialValues = () => {
    const values = selectedFile
      ? {
          ...selectedFile,
        }
      : {
          id: 0,
          fileTypeId: null,
          fileUrl: null,
          dateAdded: null,
          addedBy: null,
          manufacturerId: manufacturerId,
          equipmentId: equipmentId,
          userId: userId,
          sitePageId: sitePageId,
          isPrimary: null,
          equipmentFeatureId: equipmentFeatureId,
          name: null,

          fileType: null,
        };
    setFormData(values as UserFile);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [selectedFile]);

  function onCloseModal() {
    setFormData({
      id: 0,
      fileTypeId: null,
      fileUrl: null,
      dateAdded: null,
      addedBy: null,
      manufacturerId: manufacturerId,
      equipmentId: equipmentId,
      userId: userId,
      sitePageId: sitePageId,
      isPrimary: null,
      equipmentFeatureId: equipmentFeatureId,
      name: null,

      fileType: null,
    });
    setShow(false);
  }
  return (
    <Modal show={show} size='2xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full'>
          <div className='w-full'>
            <div className='mx-1 flex items-end justify-center'>
              <div className='flex flex-1 justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>Add File</h1>
              </div>
            </div>
          </div>

          <div>
            <div className='container mx-auto p-2'>
              <div className='md:flex no-wrap md:-mx-2 '>
                {/* <!-- Right Side --> */}
                <div className='w-full'>
                  {/* <!-- Profile tab --> */}
                  {/* <!-- About Section --> */}
                  <div className='bg-white'>
                    <hr className='bg-gray-300 h-[5px]'></hr>
                    <form id='fileModal' onSubmit={onSubmit}>
                      <div className='text-gray-500'>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              File Type:
                            </div>
                          </div>
                          <div className='flex'>
                            <div className='w-full'>
                              <Select
                                id='fileTypeId'
                                name='fileTypeId'
                                onChange={handleChangeSelect}
                                value={formData.fileTypeId ?? ''}
                                sizing='md'
                                required
                              >
                                <option value={''}>(Select Type)</option>
                                {fileTypes
                                  .filter((x) => x.name !== 'Photo')
                                  .map((ft) => (
                                    <option key={ft.id} value={ft.id}>
                                      {ft.name}
                                    </option>
                                  ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Name:
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='name'
                              name='name'
                              type='text'
                              placeholder='File Name...'
                              onChange={handleChangeInput}
                              value={formData.name ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              File:
                            </div>
                          </div>
                          <div className='w-full'>
                            <FileInput
                              id='file-upload'
                              onChange={handleFileChange}
                              disabled={buttonDisabled || formData.id > 0}
                              required={formData.id === 0}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-end pt-2'>
                        <Button
                          disabled={buttonDisabled}
                          type='submit'
                          className='buttonMain'
                          form='fileModal'
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                  {/* <!-- End of profile tab --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
